import Column from "@amzn/meridian/column";
import Loader from "@amzn/meridian/loader";
import React from "react";

import { maskLoaderStyle } from "../styles/Style";
import { IColumnAlignmentHorizontal, IColumnAlignmentVertical, ILoaderProps } from "../types/Loader.types";

const CustomLoader = ({
  loaderSize,
  loaderType,
  loaderHeight,
  loaderWidth,
  loaderPercentage,
  loaderPercentageText,
  alignmentHorizontal,
  alignmentVertical,
  spacing,
  spacingInset,
  isMaskLoaderEnabled
}: ILoaderProps) => {
  const defaultAlignmentVertical: IColumnAlignmentVertical = alignmentVertical || "center";
  const defaultAlignmentHorizontal: IColumnAlignmentHorizontal = alignmentHorizontal || "center";

  return (
    <Column
      data-testid="customloader-container-column"
      height={loaderHeight}
      width={loaderWidth}
      alignmentHorizontal={defaultAlignmentHorizontal}
      alignmentVertical={defaultAlignmentVertical}
      spacing={spacing}
      spacingInset={spacingInset}
      className={isMaskLoaderEnabled && maskLoaderStyle}
    >
      <Loader
        data-testid="customloader-progress-loader"
        type={loaderType}
        size={loaderSize}
        percentage={loaderPercentage}
        showPercentageText={loaderPercentageText}
      />
    </Column>
  );
};

export default CustomLoader;
